/**
 * The single source of truth for update Fitness legal page URLs.
 *
 * Keyed by legal document, then by {@link LegalLanguage}. All consuming apps
 * (auth, desktop, door, and the shared login page) resolve their links from
 * here so the URLs are never duplicated or allowed to drift.
 */
export const LEGAL_URLS = {
    impressum: {
        de: 'https://www.update-fitness.ch/impressum/',
        fr: 'https://www.update-fitness.ch/fr_ch/impressum/',
        it: 'https://www.update-fitness.ch/it/impressum/',
        en: 'https://www.update-fitness.ch/impressum/',
    },
    datenschutz: {
        de: 'https://www.update-fitness.ch/datenschutz/',
        fr: 'https://www.update-fitness.ch/fr_ch/protectiondesdonnees/',
        it: 'https://www.update-fitness.ch/it/protezione-dei-dati/',
        en: 'https://www.update-fitness.ch/datenschutz/',
    },
};
//# sourceMappingURL=legal_urls.js.map